import React from 'react';
import { useTranslation } from 'react-i18next';
import { Mail, Phone } from 'lucide-react';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-slate-50 text-slate-600 border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          
          {/* Company Info */}
          <div className="space-y-6">
            <div className="flex items-center gap-2">
              <img 
                src="/logos/haj-en-ar.svg" 
                alt="Haj Logistics" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-sm leading-relaxed text-slate-500">
              {t('footer.desc')}
            </p>

          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-slate-900 font-semibold text-lg mb-6">{t('footer.quick_links')}</h3>
            <ul className="space-y-4">
              <li><a href="#about" className="hover:text-marine-600 transition-colors">{t('footer.links.about')}</a></li>
              <li><a href="#services" className="hover:text-marine-600 transition-colors">{t('footer.links.services')}</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-slate-900 font-semibold text-lg mb-6">{t('footer.services')}</h3>
            <ul className="space-y-4">
              <li><a href="#services" className="hover:text-marine-600 transition-colors">{t('footer.links.cargo')}</a></li>
              <li><a href="#services" className="hover:text-marine-600 transition-colors">{t('footer.links.agency')}</a></li>
              <li><a href="#services" className="hover:text-marine-600 transition-colors">{t('footer.links.customs')}</a></li>
              <li><a href="#services" className="hover:text-marine-600 transition-colors">{t('footer.links.project')}</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div id="contact">
            <h3 className="text-slate-900 font-semibold text-lg mb-6">{t('footer.contact')}</h3>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-marine-500" />
                <span dir="ltr">{t('footer.phone')}</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-marine-500" />
                <span>info@haj-logistics.com</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      
      <div className="border-t border-slate-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-500">
            © {new Date().getFullYear()} {t('footer.rights')}
          </p>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
